// extracted by mini-css-extract-plugin
export default {"wrapper":"Close_wrapper__bof92"};